import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { LinkButton } from '@atlaskit/button/new';

import { ConfluencePageSubType } from '@confluence/create-blank-fabric-page/entry-points/CreateBlankPageMutation.ts';
import { buildCreationLink } from '@confluence/create-blank-fabric-page/entry-points/createContentRouteUtils.ts';

const i18n = defineMessages({
	createPage: {
		id: 'home.home-views.create-page',
		defaultMessage: 'Create a page',
		description: 'Text of a button which, when clicked, creates a page',
	},
	createLivePage: {
		id: 'home.home-views.create-live-doc',
		defaultMessage: 'Create a live doc',
		description: 'Text of a button which, when clicked, creates a live page',
	},
});

export const CreatePageButton = ({
	appearance,
	creationLinkSource,
	showCreateLivePageButton,
}: {
	appearance: any;
	creationLinkSource: any;
	showCreateLivePageButton: any;
}): React.JSX.Element => {
	const creationHref = buildCreationLink({
		contentType: 'page',
		source: creationLinkSource,
		withFallback: true,
		subType: ConfluencePageSubType.LIVE,
	});

	return (
		<LinkButton href={creationHref} appearance={appearance} shouldFitContainer={false}>
			<FormattedMessage {...(showCreateLivePageButton ? i18n.createLivePage : i18n.createPage)} />
		</LinkButton>
	);
};
